const repair = {
	select_image: function (event) {
		if (!event) return null;

		const file = event.target.files[0];

		if (!file) return null;

		const preview = document.getElementById('preview-image');
		preview.src = URL.createObjectURL(file);
		preview.classList.add('active');
		preview.onload = () => URL.revokeObjectURL(preview.src);

		const select = document.querySelector('.product-repair-form__upload');
		select.classList.remove('active');

		const remove_btn = document.getElementById('remove-image');
		remove_btn.classList.add('active');
	},
	remove_image: function () {
		const select = document.querySelector('.product-repair-form__upload');
		select.classList.add('active');

		const select_input = select.querySelector('input');
		select_input.value = '';

		const preview = document.getElementById('preview-image');
		preview.src = '';
		preview.classList.remove('active');

		const remove_btn = document.getElementById('remove-image');
		remove_btn.classList.remove('active');
	},
	add_to_cart: async function () {
		const form = document.getElementById('product-repair-form');
		if (!form) return null;

		VermontGlove.cart.request(true);

		const select_input = document.querySelector('input[name="image"]');
		let image_url = null;

		if (select_input?.files?.[0]) {
			const file = select_input.files[0];

			const renamed_file = new File([file], `${new Date().getTime()}-${file.name}`, {
				type: file.type,
				lastModified: file.lastModified
			});

			const upload_data = new FormData();
			upload_data.append('image', renamed_file);

			const upload_req = await VermontGlove.api.heroku.upload(upload_data);
			if (upload_req) image_url = upload_req;
		}

		const { product } = VermontGlove;
		const form_data = new FormData(form);
		let add_ons = {};

		for (const entry of form_data.entries()) {
			if (entry[0].toLowerCase() == 'add-on') add_ons[entry[1]] = true;
		}

		const obj = {
			id: product.variants[0].id,
			quantity: 1,
			properties: {
				Name: form.name.value,
				Email: form.email.value,
				Phone: form.phone.value,
				Date: form.date.value,
				'Where did you purchase your gloves?': form.where.value,
				'What happened / What’s wrong with them?': form.what.value,
				image_url
			}
		};

		const req = await VermontGlove.api.cart.add(obj);

		const addons_arr = Object.keys(add_ons);
		if (addons_arr.length) {
			let addon_index = 0;
			const _add_to_cart = async function () {
				if (addon_index >= addons_arr.length) return null;

				const key = addons_arr[addon_index];
				const addon = VermontGlove.addons[key];
				if (!addon?.variants?.[0]?.id) {
					addon_index = addon_index + 1;
					return await _add_to_cart();
				}

				await VermontGlove.api.cart.add({
					id: addon.variants[0].id,
					quantity: 1,
					properties: { _cartParent: req.key }
				});

				addon_index = addon_index + 1;
				return await _add_to_cart();
			};

			await _add_to_cart();
		}

		repair.remove_image();
		await VermontGlove.cart.ui();
		VermontGlove.cart.toggle();
	}
};

window.VermontGlove = window.VermontGlove || {};
window.VermontGlove.repair = repair;

export default repair;
